import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import Chart from 'chart.js';

export default {
    name: 'analytics',
    components: {
        DatePicker,
        Chart
    },
    data() {
        return {
            url: window.location.protocol + '//' + window.location.hostname + '/index.php/',
            salons: [],
            salon_selected: null,
            dates_selected: [moment(new Date(), "DD-MM-YYYY").add(-6, "days").format('MMM D, YYYY'), moment(new Date(), "DD-MM-YYYY").format('MMM D, YYYY')],
            today_cust_report: {},
            new_customers: 0,
            returning_customers: 0,
            line_chart: '',
            pie_chart: '',
            pie_chart_data: {
                type: 'doughnut',
                data: {
                    labels: ['New', 'Returning'],
                    datasets: [
                        {
                            data: [0, 0],
                            backgroundColor: [
                                '#10A377',
                                '#FB6672',
                            ],
                        }
                    ],
                    options: {
                        legend: {
                            display: false,
                        },
                    }
                },
                options: {
                    responsive: true,
                }

            },

            line_chart_data: {
                type: 'line',
                data: {
                    datasets: [{
                            label: 'Services',
                            data: [],
                            fill: false,
                            borderColor: '#FB6672',
                            lineTension: 0.02,
                            borderWidth:2,
                            backgroundColor: "rgba(225,0,0,0.4)",
//                            borderColor: "red", // The main line color
                            borderCapStyle: 'square',
                            borderDash: [], // try [5, 15] for instance
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: "black",
                            pointBackgroundColor: "#FB6672",
                            pointBorderWidth: 0.02,
                            pointHoverRadius: 8,
                            pointHoverBackgroundColor: '#FB6672',
                            pointHoverBorderColor: "brown",
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 2,
                        },
                        {
                            label: 'Classes',
                            data: [],
                            fill: false,
                            borderColor: '#F2994A',
                            lineTension: 0.02,
                            borderWidth:2,
                            backgroundColor: "rgba(225,0,0,0.4)",
//                            borderColor: "red", // The main line color
                            borderCapStyle: 'square',
                            borderDash: [], // try [5, 15] for instance
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: "black",
                            pointBackgroundColor: "#F2994A",
                            pointBorderWidth: 0.02,
                            pointHoverRadius: 8,
                            pointHoverBackgroundColor: '#F2994A',
                            pointHoverBorderColor: "brown",
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 2,
                        },
                        {
                            label: 'Products',
                            data: [],
                            fill: false,
                            borderColor: '#0084F4',
                            lineTension: 0.02,
                            borderWidth:2,
                            backgroundColor: "rgba(225,0,0,0.4)",
//                            borderColor: "red", // The main line color
                            borderCapStyle: 'square',
                            borderDash: [], // try [5, 15] for instance
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: "black",
                            pointBackgroundColor: "#0084F4",
                            pointBorderWidth: 0.02,
                            pointHoverRadius: 8,
                            pointHoverBackgroundColor: "#0084F4",
                            pointHoverBorderColor: "brown",
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            pointHitRadius: 2,
                        },
                    ],
                    options: {
                        tooltips:{
                          mode: 'index',
                          position:'nearest',
                          intersect: false,
                          titleFontSize:18,
                          bodyFontSize: 17,
                          bodySpacing: 8,
                          cornerRadius:12,
                          xPadding:15,
                          yPadding:15,
                          callbacks:{
                              title:function(TooltipItem){
                                  return moment(TooltipItem[0].label).format('MMM DD, YYYY');
                              },
                              label: function (tooltipItems) {
                                    return  "$"+new Intl.NumberFormat().format(tooltipItems.yLabel);
                              }
                          }
                        },
                        legend: {
                            display: false,
                        },
                        responsive: true,
                        plugins: {
                            tooltip: {
                                mode: 'index'
                            }
                        },
                        elements: {
                            point: {
                                radius: 0,
                            }
                        },
                        scales: {
                            yAxes: [{
                                    ticks: {
                                        maxTicksLimit: 4
                                    }
                                }],
                            xAxes: [{
                                    type: 'time',
                                    time: {
                                        unit:'day',
                                        displayFormats: {
                                            day: 'MMM DD'
                                        }
                                    }
                                },
                            ]
                        },
                    }
                }
            },
            top_five_customers: [],
            top_five_stylists: [],
            top_five_services: [],
            top_five_products: [],
            revenue_data: {},
            services_revenue_percent: 0,
            classes_revenue_percent: 0,
            products_revenue_percent: 0,
        }
    },

    async mounted() {
        this.$store.state.menu_toggle = false;
        await this.getStore();
        this.today_customer_reports();
        this.createChart('pie_chart', this.pie_chart_data);
        this.createChart('line_chart', this.line_chart_data);
        this.get_all_reports();
    },

    created() {
        window.addEventListener("resize", this.onResize);
    },

    destroyed() {
        window.removeEventListener("resize", this.onResize);
    },

    methods: {
        onResize() {
            this.windowHeight = window.innerHeight - 250;
        },

        get_all_reports(type) {
            this.get_new_and_returning_customers(type);
            this.get_revenue_of_salon();
            this.get_top_five_customers();
            this.get_top_five_stylists();
            this.get_top_five_services();
            this.get_top_five_products();
        },

        async getStore() {
            await this.$store.dispatch('getStoreByOwnerId', [this.$store.state.api, this.$store.state.user_id]);

            if (Object.keys(this.$store.state.stores_data).length > 0) {
                this.salons = this.$store.state.stores_data;
            }

            this.salon_selected = this.$store.state.stores_data[0].store_id;
        },

        async get_new_and_returning_customers(type) {

            if (type == 1) {
                this.today_customer_reports();
            }

            await this.$store.dispatch('get_new_and_returning_customers', [this.$store.state.api, {"store_id": this.salon_selected, "start_date": moment(this.dates_selected[0]).format('YYYY-MM-DD'), "end_date": moment(this.dates_selected[1]).format('YYYY-MM-DD')}]);

            this.pie_chart_data.data.datasets[0].data[0] = this.$store.state.customer_reports.new_customers;
            this.pie_chart_data.data.datasets[0].data[1] = this.$store.state.customer_reports.returning_customers;
            this.pie_chart.data = this.pie_chart_data.data;
            this.pie_chart.update();
//            this.createChart('pie_chart', this.pie_chart_data)

        },

        async get_revenue_of_salon() {
            await this.$store.dispatch('get_revenue_report', [this.$store.state.api, {"store_id": this.salon_selected, "start_date": moment(this.dates_selected[0]).format('YYYY-MM-DD'), "end_date": moment(this.dates_selected[1]).format('YYYY-MM-DD')}]);


            let labels_array = [];
            this.$store.state.revenue_reports.revenue.services.graph_data.labels.forEach(date => {
                labels_array.push(moment(date))
            })

            this.revenue_data = this.$store.state.revenue_reports.revenue;

            let total_revenue = this.revenue_data.total_revenue;

            this.services_revenue_percent = (this.revenue_data.services.total_booking_revenue / total_revenue) * 100 ? (this.revenue_data.services.total_booking_revenue / total_revenue) * 100 : 0;
            this.classes_revenue_percent = (this.revenue_data.classes.total_booking_revenue / total_revenue) * 100 ? (this.revenue_data.classes.total_booking_revenue / total_revenue) * 100 : 0;
            this.products_revenue_percent = (this.revenue_data.products.total_booking_revenue / total_revenue) * 100 ? (this.revenue_data.products.total_booking_revenue / total_revenue) * 100 : 0;

            this.line_chart_data.data.labels = labels_array;

            this.line_chart_data.data.datasets[0].data = this.$store.state.revenue_reports.revenue.services.graph_data.values;
            this.line_chart_data.data.datasets[1].data = this.$store.state.revenue_reports.revenue.classes.graph_data.values;
            this.line_chart_data.data.datasets[2].data = this.$store.state.revenue_reports.revenue.products.graph_data.values;
//            this.createChart('line_chart', this.line_chart_data);
            if(labels_array.length <= 31){
                this.line_chart.options.scales = {
                            yAxes: [
                                {
                                    ticks: {
                                        maxTicksLimit: 4
                                    }
                                }],
                            xAxes: [{
                                    gridLines:{
                                        drawBorder:false
                                    },
                                    type: 'time',
                                    time: {
                                        unit:'day',
                                        displayFormats: {
                                            day: 'MMM DD'
                                        }
                                    }
                                },
                            ]
                        }
            }
            else if(labels_array.length > 31 && labels_array.length <= 93){
                this.line_chart.options.scales = {
                            yAxes: [{
                                    ticks: {
                                        maxTicksLimit: 4
                                    }
                                }],
                            xAxes: [{
                                    gridLines:{
                                        drawBorder:false
                                    },
                                    type: 'time',
                                    time: {
                                        unit:'week',
                                        displayFormats: {
                                            day: 'MMM DD'
                                        }
                                    }
                                },
                            ]
                        }
            }
            else if(labels_array.length > 93){
                this.line_chart.options.scales = {
                            yAxes: [{
                                    ticks: {
                                        maxTicksLimit: 4
                                    }
                                }],
                            xAxes: [{
                                    gridLines :{
                                        display: false
                                    },
                                    type: 'time',
                                    time: {
                                        unit:'month',
                                        displayFormats: {
                                            day: 'MMM YYYY'
                                        }
                                    }
                                },
                            ]
                        }
            }
            this.line_chart.data = this.line_chart_data.data;
            this.line_chart.update();

            setTimeout(() => {
                this.$nextTick(() => {
                    this.$refs.services_progress.style.width = this.services_revenue_percent + '%';
                    this.$refs.classes_progress.style.width = this.classess_revenue_percent + '%';
                    this.$refs.products_progress.style.width = this.products_revenue_percent + '%';
                });
            }, 100);
        },

        async get_top_five_customers() {
            await this.$store.dispatch('top_five_customers_report', [this.$store.state.api, {"store_id": this.salon_selected, "start_date": moment(this.dates_selected[0]).format('YYYY-MM-DD'), "end_date": moment(this.dates_selected[1]).format('YYYY-MM-DD')}]);

            this.top_five_customers = this.$store.state.top_five_customers_reports;
        },

        async get_top_five_stylists() {
            await this.$store.dispatch('top_five_stylists_report', [this.$store.state.api, {"store_id": this.salon_selected, "start_date": moment(this.dates_selected[0]).format('YYYY-MM-DD'), "end_date": moment(this.dates_selected[1]).format('YYYY-MM-DD')}]);

            this.top_five_stylists = this.$store.state.top_five_stylists_reports;
        },

        async get_top_five_services() {
            await this.$store.dispatch('top_five_services_report', [this.$store.state.api, {"store_id": this.salon_selected, "start_date": moment(this.dates_selected[0]).format('YYYY-MM-DD'), "end_date": moment(this.dates_selected[1]).format('YYYY-MM-DD')}]);

            this.top_five_services = this.$store.state.top_five_services_reports;
        },

        async get_top_five_products() {
            await this.$store.dispatch('top_five_products_report', [this.$store.state.api, {"store_id": this.salon_selected, "start_date": moment(this.dates_selected[0]).format('YYYY-MM-DD'), "end_date": moment(this.dates_selected[1]).format('YYYY-MM-DD')}]);

            this.top_five_products = this.$store.state.top_five_products_reports;
        },

        createChart(chartId, chartData) {
            if (chartId === 'line_chart') {
                const ctx = document.getElementById(chartId);

                this.line_chart = new Chart(ctx, {
                    type: chartData.type,
                    data: chartData.data,
                    options: chartData.data.options
                });
            } else {
                const ctx = document.getElementById(chartId);

                this.pie_chart = new Chart(ctx, {
                    type: chartData.type,
                    data: chartData.data,
                    options: chartData.data.options
                });
            }
        },

        async today_customer_reports() {
            await this.$store.dispatch('get_new_and_returning_customers', [this.$store.state.api, {"store_id": this.salon_selected, "start_date": moment(new Date(), "DD-MM-YYYY").format('YYYY-MM-DD'), "end_date": moment(new Date(), "DD-MM-YYYY").format('YYYY-MM-DD')}]);

            this.today_cust_report = this.$store.state.customer_reports;
        },

        report_redirection(type, subtype) {
            this.$session.set('reports_obj', {selected_store: this.salon_selected, 'type': type, 'subtype': subtype, 'selected_dates': this.dates_selected})
            this.$router.push('/reports');
        }
    }
}